module.exports = __webpack_public_path__ + "static/media/UP-TURN.3c3fdd84.webp";